import { IQueryCommandOptions, mergeQueryCommandOptions } from '@llws/dynamic-router-utils';

/**
 *
 * @param commands Merge array of IQueryCommandOptions
 * @returns IQueryCommandOptions
 */
export const mergeQueryCommandOptionsV2 = (commands: IQueryCommandOptions[]): IQueryCommandOptions => ({
  ...mergeQueryCommandOptions(commands),
});
